import { v4 as uuidv4 } from 'uuid';
import { getDiscoverPublishersAPI } from './api';
import {
    DIRECTORY_PAGE_LIMIT,
    preparePublisherData,
    deriveDirectoryFilterIndustries,
} from './getDirectoryPublishers';

// Guards against firing a second request while one is already in flight
// (VirtuosoGrid's endReached can fire again before the first page lands),
// and against fetching past the last page the API told us about.
function canLoadMoreDirectoryPublishers(store) {
    return store.directoryHasMore
        && !store.observed.directoryPublishersLoading
        && !store.observed.directoryPublishersLoadingMore;
}

async function loadMoreDirectoryPublishers() {
    if (!canLoadMoreDirectoryPublishers(this)) return;

    this.observed.directoryPublishersLoadingMore = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;
        const nextPage = this.directoryPage + 1;

        const res = await getDiscoverPublishersAPI({
            token: session?.token,
            traceId,
            page: nextPage,
            limit: DIRECTORY_PAGE_LIMIT,
        });
        // The API layer resolves (never rejects) even on a network/HTTP
        // failure, returning the raw error in place of a response — so a
        // failed request has no `.data`. Bail out without advancing
        // directoryPage/directoryHasMore so the next scroll-triggered call
        // retries this same page, instead of silently skipping it forever.
        if (!res?.data) return;

        const data = res.data?.data || res.data;
        const publishers = data?.publishers || [];
        const colored = preparePublisherData(publishers, this.whatshotPublishers);

        // Append, never replace — the browse-mode list keeps growing as the
        // user scrolls (EBL-13079).
        this.directoryPublishers = [...this.directoryPublishers, ...colored];
        this.directoryFilterIndustries = deriveDirectoryFilterIndustries(this.directoryPublishers);
        this.directoryPage = nextPage;
        this.directoryHasMore = !!data?.hasNextPage;
        this.observed.directoryPublishers = uuidv4();
        this.applyDirectoryFilter();
    } finally {
        this.observed.directoryPublishersLoadingMore = false;
    }
}

export default loadMoreDirectoryPublishers;
